import { css } from '@emotion/react';
export const errorContainerStyle = css `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
//# sourceMappingURL=error-icon.styles.js.map